
(function(){
  'use strict';
  function setup(){
    var section=document.querySelector('[data-pc-pvc-preview]');
    if(!section)return;
    document.querySelectorAll('[data-pc-pvc-card]').forEach(function(card){
      if(card.dataset.pcBound)return;
      card.dataset.pcBound='1';
      var btn=card.querySelector('[data-pc-pvc-card-add]');
      var feedback=card.querySelector('[data-pc-pvc-card-feedback]');
      if(!btn)return;
      btn.addEventListener('click',function(){
        var api=window.PCPreviewCart;
        if(!api){if(feedback)feedback.textContent='Preview basket is loading. Retry.';return;}
        var min=Number(card.dataset.pcPreviewMin)||1;
        var item={code:card.dataset.pcPreviewCode,title:card.dataset.pcPreviewTitle,
                  image:card.dataset.pcPreviewImage,price:Number(card.dataset.pcPreviewPrice)};
        if(api.add(item,min)){
          btn.classList.add('is-added');btn.textContent='✓ Added to Cart';
          if(feedback)feedback.textContent=min+' panel(s) added · '+api.count()+' items in bag';
        }else if(feedback)feedback.textContent='Could not update the preview basket.';
      });
    });
    var params=new URLSearchParams(window.location.search);
    var code=params.get('pvc_preview');
    if(!code){document.documentElement.classList.remove('pc-pvc-detail-view');return;}
    var root=section.querySelector('[data-pc-pvc-details]');
    if(!root)return;
    var selected=null;
    root.querySelectorAll('[data-pc-pvc-detail]').forEach(function(article){
      var match=article.dataset.pcPvcDetail===code;
      article.hidden=!match;
      if(match)selected=article;
    });
    if(!selected){document.documentElement.classList.remove('pc-pvc-detail-view');return;}
    document.documentElement.classList.add('pc-pvc-detail-view');
    if(selected.dataset.pcBound)return;
    selected.dataset.pcBound='1';
    var main=selected.querySelector('[data-pc-pvc-main-image]');
    var thumbs=Array.prototype.slice.call(selected.querySelectorAll('[data-pc-pvc-thumb]'));
    var index=0;
    function choose(i){
      if(!thumbs.length)return;
      index=(i+thumbs.length)%thumbs.length;
      var url=thumbs[index].dataset.pcPvcThumb;
      if(main&&url)main.src=url;
      thumbs.forEach(function(el,n){el.classList.toggle('is-active',n===index);el.setAttribute('aria-pressed',n===index?'true':'false');});
    }
    thumbs.forEach(function(el,n){el.addEventListener('click',function(){choose(n);});});
    var left=selected.querySelector('[data-pc-pvc-prev]');
    var right=selected.querySelector('[data-pc-pvc-next]');
    if(left)left.addEventListener('click',function(){choose(index-1);});
    if(right)right.addEventListener('click',function(){choose(index+1);});
    var min=Number(selected.dataset.pcPreviewMin)||1;
    var qty=selected.querySelector('[data-pc-pvc-qty]');
    var price=Number(selected.dataset.pcPreviewPrice)||0;
    var total=selected.querySelector('[data-pc-pvc-line-total]');
    function update(){
      if(!qty)return min;
      var n=Math.max(min,Math.min(999,Math.floor(Number(qty.value)||min)));
      qty.value=String(n);
      if(total)total.textContent='£'+(n*price).toFixed(2);
      return n;
    }
    var minus=selected.querySelector('[data-pc-pvc-minus]');
    var plus=selected.querySelector('[data-pc-pvc-plus]');
    if(minus)minus.addEventListener('click',function(){qty.value=(Number(qty.value)||min)-1;update();});
    if(plus)plus.addEventListener('click',function(){qty.value=(Number(qty.value)||min)+1;update();});
    if(qty)qty.addEventListener('change',update);
    if(qty)qty.addEventListener('input',update);
    var add=selected.querySelector('[data-pc-pvc-add]');
    var feedback=selected.querySelector('[data-pc-pvc-detail-feedback]');
    if(add)add.addEventListener('click',function(){
      var api=window.PCPreviewCart;
      if(!api){if(feedback)feedback.textContent='Preview basket is loading. Retry.';return;}
      var n=update();
      var item={code:code,title:selected.dataset.pcPreviewTitle,
                image:selected.dataset.pcPreviewImage,price:price};
      if(api.add(item,n)){
        add.classList.add('is-added');
        add.textContent='✓ Added to Cart';
        if(feedback)feedback.textContent=n+' panel(s) added to basket · '+api.count()+' items total';
      }else if(feedback)feedback.textContent='Could not save your selected panels.';
    });
    update();
    window.scrollTo(0,0);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();
